<template>
    <header class="header">
        <div class="header__container">
            <div class="header__wrapper">
                <router-link :to="'/'" v-if="options['Header']">
                    <img :src="`${this.$store.state.base_directory}${options['Header']['Logo Header'].replace(/^public\//, '')}`" alt="Изображение">
                </router-link>
            <ul>
                <li v-for="page in pages" :key="page.id"><router-link :to="page.url">{{ page.title }}</router-link></li>
            </ul>
            <div class="button__wrapper">
            
                <div style="display: flex; gap: 16px;">
                    <div class="search burger" @click="dialogs.dialodMenuMobile = true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_429_11066)">
                        <path d="M3 6.00092H21M3 12.0009H21M3 18.0009H21" stroke="#292929" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_429_11066">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.000915527)"/>
                        </clipPath>
                        </defs>
                        </svg>
                    </div>
                    <div class="search-container" v-click-outside="() => handleClickOutside()">
                        <div class="search-button" @click="isSearchActive = !isSearchActive; isDropdownVisible = false">
                        <svg width="13.542667" height="13.542725" viewBox="0 0 13.5427 13.5427" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.68 9.74L13.54 12.59L12.59 13.54L9.74 10.68C8.68 11.53 7.36 12 6 12C2.68 12 0 9.31 0 6C0 2.68 2.68 0 6 0C9.31 0 12 2.68 12 6C12 7.36 11.53 8.68 10.68 9.74ZM9.35 9.25C10.19 8.37 10.66 7.21 10.66 6C10.66 3.42 8.57 1.33 6 1.33C3.42 1.33 1.33 3.42 1.33 6C1.33 8.57 3.42 10.66 6 10.66C7.21 10.66 8.37 10.19 9.25 9.35L9.35 9.25Z" fill="#050505"/>
                        </svg>
                        </div>
                        <input type="text" 
                        v-model="searchQuery"
                        @focus="isDropdownVisible = true"
                        @input="onInput($event.target.value)"
                        class="search-input" 
                        v-bind:class="{ 'active': isSearchActive }" 
                        placeholder="Search...">
                        <ul v-if="isDropdownVisible === true"  class="dropdown">
                            <div class="title">Pages</div>
                            <li v-for="post in results.pages">
                                <router-link class="search-item" :to="post.url">{{ post.title }}</router-link>
                            </li>
                            <div class="title">Product</div>
                            <li v-for="post in results.products">
                                <router-link class="search-item" :to="{
                                        name: 'product',
                                        params: {
                                        slug: post.slug
                                        },
                                    }">{{ post.name }}</router-link>
                            </li>
                            <div class="title">Blog</div>
                            <li v-for="post in results.blog_posts">
                                <router-link class="search-item" :to="{
                                        name: 'product',
                                        params: {
                                        slug: post.slug
                                        },
                                    }">{{ post.title }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <button v-if="user.id == null" class="login" @click='this.$router.push({name: "login"})'>Login</button>
                <div v-else class="search" @click='this.$router.push({name: "AccountOrders"})'>
                    <svg width="16.000000" height="16.000000" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <clipPath id="clip326_21575">
                                <rect id="Icons" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                            </clipPath>
                        </defs>
                        <rect id="Icons" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                        <g clip-path="url(#clip326_21575)">
                            <path id="Vector" d="M8 6.66C6.52 6.66 5.33 5.47 5.33 4C5.33 2.52 6.52 1.33 8 1.33C9.47 1.33 10.66 2.52 10.66 4C10.66 5.47 9.47 6.66 8 6.66Z" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.200000" stroke-linejoin="round"/>
                            <path id="Vector" d="M14 14.66C14 11.35 11.31 8.66 8 8.66C4.68 8.66 2 11.35 2 14.66" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.200000" stroke-linejoin="round" stroke-linecap="square"/>
                        </g>
                    </svg>
                </div>
            </div>
            </div>
        </div>
        <MobileMenu  v-model:show="dialogs.dialodMenuMobile" :pages="pages"></MobileMenu>
    </header>
</template>

<script>
import MobileMenu from "@/components/Header/MobileMenu.vue";
import axios from "axios";
export default {
    components: {
        MobileMenu,
    },
    data() {
        return {
            dialogs: {
                dialodMenuMobile: false,
                 
            },
            isSearchActive: false,
            isDropdownVisible: false,
            pages: [],
            results: [],
        }
    },
    created() {
        this.fetchPages();
        this.fetchSearchResults('');
    },
    methods: {
        handleClickOutside(){
        this.isSearchActive = false;
        this.isDropdownVisible = false;
        },
        async fetchPages() {
        try {
            const response = await axios.get('/pages');
            this.pages = response.data;
        } catch (error) {
            console.error('Error fetching pages:', error);
        }
        },
        onInput(value) {
            this.fetchSearchResults(value);
        },
        async fetchSearchResults(value) {
            try {
                let fData = new FormData();
                fData.append("query", value);
                const response = await axios.post(`/search`, fData);
                this.results = response.data;
            } catch (error) {
                this.results = { pages: [], products: [], blog_posts: [] };
            }
        },
    },
    mounted () {
        
    },
    computed: {
        user() {
        return this.$store.state.user;
        },
        options() {
            return this.$store.state.options;
        },
    },
}
</script>

<style scoped>

.dropdown {
    height: unset;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    list-style: none;
    padding: 0;
    margin: 4px 0 0 0;
    max-height: 400px;
    overflow-y: auto;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: unset;
}
  .dropdown .title{
    color: rgb(5, 5, 5);
    font-size: 20px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    border-top: 1px solid rgb(222, 230, 234);
    border-bottom: 1px solid rgb(222, 230, 234);
    padding: 10px 0;
  }
  .dropdown .title:first-of-type{
    border-top: unset;
  }
  .dropdown li {

    padding: unset;
    align-items: unset;
  }
  .dropdown li a{
    height: 100%;
    width: 100%;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding: 10px;
    cursor: pointer;
  }
  .dropdown li:hover {
    background: #f0f0f0;
  }


.search-container {
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.search-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  width: 0; /* изначальная ширина обертки - 0 */
  overflow: hidden;
  transition: width 0.3s ease-in-out;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
}

.search-button {
  cursor: pointer;
  z-index: 2;
  display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    width: 32px;
    height: 32px;
    background: rgb(222, 230, 234);
    position: absolute;
    left: 0;
    top: 0;


}
.search-input:focus {/* Убираем выделение бордера при фокусе */
  outline: none; /* Убираем стандартное выделение (outline) при фокусе */
}
.search-input {
  width: 0;
  padding-left: 32px;
  box-sizing: border-box;
    border: 1px solid rgb(233, 233, 237);
    background: rgb(255, 255, 255);
  opacity: 0;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  border-radius: 16px 9px 9px 16px;

    color: rgb(86, 86, 95);
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}

.search-input.active {
  width: 300px; /* ширина, на которую развернется инпут */
  opacity: 1;
  padding-left: 40px;
}



.search.burger{
    display: none;
}
span,
span::before,
span::after {
  position: absolute;
  top: 50%; margin-top: -1px;
  left: 50%; margin-left: -8px;
  width: 15px;
  height: 2px;
  background-color: #222;
}
span::before,
span::after {
  content: '';
  display: block;
  transition: 0.2s;
}
span::before {
  transform: translateY(-5px);
}
span::after {
  transform: translateY(5px);
}
.header {
    position: fixed;
    left: 0;
    top: 0px;
    z-index: 50;
    width: 100%;
    background-color: white;
    height: 66px;
    border-bottom: 1px solid rgb(222, 230, 234);
}
.header__wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 66px;
}
ul{
    display: flex;
    height: 100%;
    align-items: center;
}
ul li{
    padding: 0 24px;
    height: 100%;
    display: flex;
    align-items: center;
}
ul li a{
    color: rgb(5, 5, 5);
}
.button__wrapper{
    display: flex;
    gap: 21px;
}
.login{
    border-radius: 32px;
    background: rgb(255, 183, 16);
    width: 81px;
    height: 32px;
    cursor: pointer;

    /* Buttons/CTA2: 13px Medium */
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.search{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    width: 32px;
    height: 32px;
    background: rgb(222, 230, 234);
    position: relative;
    cursor: pointer;
}
@media (max-width: 1024px) { 
    ul{
        display: none;
    }
    .search.burger{
        display: flex;
    }
    .button__wrapper{
        gap: 16px;
    }

}
@media (max-width: 1024px) { 
    .search-container{
        display: none;
    }
}
</style>